
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"42","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.695 14.984a3.703 3.703 0 00-1.063-.149c-1.868 0-3.376 1.763-3.376 3.824 0 .934.465 1.614 1.401 1.614 1.232 0 2.358-1.571 2.592-2.89l.446-2.4zM22.08 25.012c-3.482 0-6.436-2.55-6.436-6.63 0-4.375 3.037-8.156 7.755-8.156 3.695 0 6.181 2.59 6.181 6.14 0 3.186-1.784 5.056-3.782 5.056-.85 0-1.636-.574-1.571-1.87h-.085c-.743 1.253-1.722 1.87-2.996 1.87-1.232 0-2.294-1-2.294-2.678 0-2.634 2.082-5.034 5.035-5.034.912 0 1.72.191 2.272.446l-.721 3.846c-.32 1.614-.064 2.358.638 2.378 1.082.022 2.294-1.423 2.294-3.887 0-3.08-1.849-5.29-5.142-5.29-3.462 0-6.372 2.741-6.372 7.053 0 3.547 2.314 5.735 5.46 5.735 1.21 0 2.335-.255 3.206-.743l.34.914c-1.168.615-2.358.85-3.782.85zm20.938-8.568L22.396 33.907l-.018-.014-8.93-7.417-12.104-10.05v23.94H43.02V16.444h-.001zM1.8 15.059l2.942 2.443V13.13L1.8 15.06zm4.286 3.528l8.216 6.853 8.048 6.712.017-.015 15.907-13.546V5.445H6.087v13.143zM18.517 4.1h7.551l-3.75-2.49-3.8 2.49zm21.101 13.463l2.957-2.503-2.957-1.964v4.467zm4.745-2.93V41.71H0V14.63l4.743-3.108V4.1h11.322L22.322 0l6.176 4.1h11.12v7.383l4.745 3.15zM22.368 32.138l-8.065-6.697 8.048 6.712.017-.015zm-8.92-5.66l8.93 7.416-.02.017-8.91-7.434z","fill":"#005149","fill-rule":"evenodd"}})])
          )
        }
      }
    